import { ListAppeals } from '~/features/common/Balance/Appeal/ListAppeals'
import { Container } from '~/shared/ui/Layout'

export function ListAppealPage() {
  return (
    <Container>
      <ListAppeals />
    </Container>
  )
}
